import React from 'react';
import { Text } from '@goodfynd/react-web.ui.text';
import { dateUtil } from '@goodfynd/react-web.utils.date-util';
import { replaceNewLines } from '@goodfynd/react-web.utils.string-util';
import { GoogleMap, Marker } from '@react-google-maps/api';

import config, { unicode } from '../../../../config';
import { StyledReviewContainer, StyledReviewText, StyledRow } from '../styles';
import type { EventData } from '../types';
const ReviewEvent = ({
  organizationName,
  eventName,
  description = '',
  dates = [],
  phone,
  firstName,
  lastName,
  location,
}: EventData) => {
  const center = {
    lat: location?.latitude ?? 0,
    lng: location?.longitude ?? 0,
  };
  return (
    <StyledReviewContainer>
      <StyledRow>
        <Text as="heading5">{organizationName}</Text>
        <Text as="subhead1">{eventName}</Text>
      </StyledRow>

      <StyledRow>
        <Text as="heading5">Description</Text>
        <StyledReviewText
          as="body2"
          dangerouslySetInnerHTML={{ __html: replaceNewLines(description) }}
        />
      </StyledRow>

      <StyledRow>
        <Text as="heading5">Date(s)</Text>
        <StyledReviewText
          align="center"
          as="body2"
          dangerouslySetInnerHTML={{
            __html: dateUtil.printDateRanges(
              dateUtil.getDateRanges(dates)?.ranges || [],
              unicode.centerDotPadded
            ),
          }}
        />
      </StyledRow>

      <hr style={{ width: 25 }} />

      <StyledRow>
        <Text as="heading5">Contact</Text>

        <Text as="body2">
          {phone}&nbsp;|&nbsp;{firstName}&nbsp;{lastName}
        </Text>
      </StyledRow>

      <StyledRow>
        <Text as="heading5">Where</Text>
        <Text align="center" as="body2">
          {location?.address}
        </Text>

        <GoogleMap
          center={center}
          zoom={17}
          mapContainerStyle={{
            height: '249px',
            width: '100%',
          }}
        >
          <Marker icon={config.env.GOOGLE_MAPS_ICON} position={center} />
        </GoogleMap>
      </StyledRow>
    </StyledReviewContainer>
  );
};

export default ReviewEvent;
